export default {
    dependencies: ['$element', 'radio', 'trackingservice'],
    callable(element, radio, trackingService) {
        radio('main-image-carousel-navigate').subscribe((index, ele, count) => {
            if (index === 2) {
                const objPageContext =
                    element.getAttribute('data-gallerylightbox-context') ||
                    'unknown';
                const eventObject = {
                    ecType: 'AD',
                    ecCategory: 'picture.viewed',
                    eventData: {
                        // eslint-disable-next-line camelcase
                        'object.page.type': objPageContext,
                        'picture.index': index,
                        'picture.count': count,
                    },
                };
                trackingService.trackEventObject(eventObject);
            } else if (index === 1) {
                // trackingService.trackEvent("navigation.view-gallery-image.click", "image.index", index);
                trackingService.trackEvent(
                    'navigation.view-gallery-image.click'
                );
            }
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/businessMonitoring.js